export default "__VITE_ASSET__BcWuPzOT__"